import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import {  Button } from "@mui/material";
import SlidingPanel from "react-sliding-side-panel";
import RKTextFieldDisable from "../../../../../../../Supporting files/RKTextFieldDisable/RKTextFieldDisable";
interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const EditDepartmentInformation: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [departmentName, setDepartmentName] = React.useState("FrontEnd");
  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      backdropClicked={() => value_update(attrName, false)}
    >
      <div>
        <Grid container spacing={3} alignItems="center">
          <Grid xs={12}>
            <h4 className="mb-0 mt-4">Edit FrontEnd Department</h4>
          </Grid>

          <Grid xs={12} className="mb-5">
            <hr />
          </Grid>
        </Grid>
        <div className="scrollable_area">
          <Grid container spacing={3}>
            <Grid xs={6}>
              <RKTextFieldDisable
                class_name="inputField"
                title="Department Name"
                value={departmentName}
                attrName={setDepartmentName}
                value_update={updateMasterState}
                warn_status={false}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container spacing={3}>
          <Grid xs={12} className="ctaBtn mt-4">
            <Button
              variant="contained"
              className="submitBtn fixedbtn"
              onClick={() => {}}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </div>
    </SlidingPanel>
  );
};

export default EditDepartmentInformation;
